export const API_URL = import.meta.env.VITE_API_URL
export const CUSTOMERS_KEY = import.meta.env.VITE_API_CUSTOMERS_KEY
 